import React, { useEffect, useState, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import {
  AvatarGroup,
  Box,
  CardContent,
  ClickAwayListener,
  Divider,
  Grid,
  IconButton,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";
import UserDetails from "./UserDetails";
import ChatDrawer from "./ChatDrawer";
import ChartHistory from "./ChartHistory";
import MainCard from "ui-component/cards/MainCard";
import Avatar from "ui-component/extended/Avatar";
import { appDrawerWidth as drawerWidth, gridSpacing } from "store/constant";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ErrorTwoToneIcon from "@mui/icons-material/ErrorTwoTone";
import SendTwoToneIcon from "@mui/icons-material/SendTwoTone";
import MoodTwoToneIcon from "@mui/icons-material/MoodTwoTone";
import HighlightOffTwoToneIcon from "@mui/icons-material/HighlightOffTwoTone";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import formatName from "reuseableTable/naming-convention";
import { ChatBubbleOutline } from "@mui/icons-material";


const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    paddingLeft: open ? theme.spacing(3) : 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
    marginLeft: `-${drawerWidth}px`,
    [theme.breakpoints.down("lg")]: {
      paddingLeft: 0,
      marginLeft: 0,
    },
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shorter,
      }),
      marginLeft: 0,
    }),
  })
);



const AlumniChatMainPage = ({ alumniDetailsInfo }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const scrollRef = useRef();
  const scrollContainerRef = useRef();

  const [isFetching, setIsFetching] = useState(false);
  const [emailDetails, setEmailDetails] = React.useState(false);
  const [openChatDrawer, setOpenChatDrawer] = React.useState(true);
  const [isFromSearchBar, setIsFromSearchBar] = React.useState(false);
  const [user, setUser] = useState({});
  const [connectionList, setConnectionList] = useState([]);
  const [data, setData] = React.useState([]);
  const [roomId, setRoomId] = React.useState("");
  const [groupMembers, setGroupMembers] = useState([]);
  const [roomMessages, setRoomMessages] = useState({});
  const [message, setMessage] = useState("");
  const [currentRoomId, setCurrentRoomId] = useState(roomId);

  const [client, setClient] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [groupMemberImages, setGroupMemberImages] = useState([]);

  const [anchorElEmoji, setAnchorElEmoji] = React.useState();
  const [isCooldown, setIsCooldown] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [getlastdata, setLastdata] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const [replyTo, setReplyTo] = useState(null);

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const handleDrawerOpen = () => {
    setOpenChatDrawer((prevState) => !prevState);
  };
  const handleUserChange = () => {
    setEmailDetails((prev) => !prev);
  };
  const maxLength = 200;

  const handleMessageChange = (e) => {
    const inputText = e.target.value;
    setMessage(inputText);
    setRoomMessages((prevMessages) => ({
      ...prevMessages,
      [currentRoomId]: inputText,
    }));
  };

  const handleRoomChange = (newRoomId) => {
    setRoomMessages((prevMessages) => ({
      ...prevMessages,
      [currentRoomId]: message,
    }));
    const newMessage = roomMessages[newRoomId] || "";
    setMessage(newMessage);
    setCurrentRoomId(newRoomId);
  };

  const generateUniqueId = async (id1, id2) => {
    if (id2 !== undefined) {
      const idStr1 = id1.toString();
      const idStr2 = id2.toString();
      const ids = [idStr1, idStr2];
      ids.sort();
      const combined = ids[0] + ids[1];
      const encoder = new TextEncoder();
      const data = encoder.encode(combined);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const base64Hash = btoa(
        String.fromCharCode(...new Uint8Array(hashBuffer))
      );
      setRoomId(base64Hash.replace("/", "a"));
      return base64Hash;
    }
  };


  const getMessage = async (roomIde) => {

    try {
      const response = await axios.get(
        `/v1/chat/message/list/page?roomId=${encodeURIComponent(
          roomIde
        )}&pageNumber=${pageNumber}&pageSize=10`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );

      setData((prevPosts) => [...response?.data?.data?.content, ...prevPosts]);
      setLastdata(response?.data?.data?.last);
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop =
          scrollContainerRef.current.scrollHeight;
      }
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
    }
  };

  const getConnectionList = async () => {
    try {
      const response = await axios.get(`/v1/connection/my`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      const connections = response?.data?.data;
      setConnectionList(connections);


      const matchingConnection = connections?.find(
        (connection) => connection.connectionId === alumniDetailsInfo.userId
      );

      if (matchingConnection) {
        setIsFromSearchBar(true);
        setUser((prevUser) => {
          if (prevUser?.connectionId !== matchingConnection.connectionId) {
            return matchingConnection;
          }
          return prevUser;
        });

        generateUniqueId(
          localStorage.getItem("userId"),
          matchingConnection?.connectionId
        );
        handleRoomChange(user?.connectionId);
        setOpenChatDrawer(false);
      }

      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };
  const clearNotification = async (connectionType, connectionId) => {
    if (connectionId === undefined) return;
    try {
      const response = await axios.put(
        `/v1/chat/clear/count?connectionId=${connectionId}&connectionType=${connectionType}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      getConnectionList();
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchGroupMembers = async (groupId) => {
    try {
      const response = await axios.get(
        `/v1/communication/group/list/group/member?groupId=${groupId}&pageNumber=0&pageSize=200`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999) + rendomRequestId
            ),
          },
        }
      );
      setGroupMembers(response?.data?.data?.content);
      const groupMembers = response?.data?.data?.content || [];
      const alumniAvatars = groupMembers.map((member) =>
        member.alumniMemberMini.avatar === null
          ? ""
          : member.alumniMemberMini.avatar.data
      );
      setGroupMemberImages((prevImages) => ({
        ...prevImages,
        [groupId]: alumniAvatars,
      }));

      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  const handleOnSend = async () => {
    if (isCooldown || message.trim().length === 0) return;

    const d = new Date();
    setMessage("");
    const newMessage = {
      id: "",
      senderId: localStorage.getItem("userId"),
      receiverId: user?.connectionId,
      roomType: user?.connectionType,
      roomId: roomId,
      content: message,
      chatContent: "Text",
      from: "User1",
      to: user.name,
      text: message,
      repliedFromId: replyTo?.id,
      time: d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    try {
      await axios.post(`/v1/chat/send`, newMessage, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      generateTimeStamp();

      const startTime = Date.now();
      localStorage.setItem("cooldownStartTime", startTime.toString());

      setIsCooldown(true);

      setTimeout(() => {

        setIsCooldown(false);
        localStorage.removeItem("cooldownStartTime");
      }, 10000);
      setReplyTo(null)
    } catch (error) {
      setReplyTo(null)
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };
  const handleEnter = (event) => {
    if (event?.key !== "Enter") {
      return;
    }
    handleOnSend();
  };
  const onEmojiClick = (event, emojiObject) => {
    setMessage(message + emojiObject.emoji);
  };

  const handleOnEmojiButtonClick = (event) => {
    setAnchorElEmoji(anchorElEmoji ? null : event?.currentTarget);
  };
  const emojiOpen = Boolean(anchorElEmoji);
  const emojiId = emojiOpen ? "simple-popper" : undefined;
  const handleCloseEmoji = () => {
    setAnchorElEmoji(null);
  };
  useEffect(() => {
    const sockClient = new Client({
      brokerURL: "ws://https://api.alumni.live/ws",
      webSocketFactory: () => new SockJS("https://api.alumni.live/ws"),
      debug: function (str) { },
      connectHeaders: {
        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });
    sockClient.activate();
    setClient(sockClient);
    return () => {
      sockClient.deactivate();
    };
  }, []);

  useEffect(() => {
    const topic = `/topic/public/${roomId}`;
    if (client && client.connected && roomId) {
      if (!subscriptions.includes(roomId)) {
        client.subscribe(`/topic/public/${roomId}`, (message) => {
          const messageSound = new Audio(
            "/assets/images/icons/mixkit-bell-notification-933.wav"
          );
          const chatMessage = JSON.parse(message.body);
          if (data.filter((item) => item.id !== chatMessage.id)) {
            setData((prevState) => [...prevState, chatMessage]);
          }
        });
        setSubscriptions((prevSubscriptions) => [...prevSubscriptions, roomId]);
      }
    }
    if (roomId) {
      setData([]);
      setPageNumber(0);
      setLastdata(false);
      getMessage(roomId);
    }
  }, [roomId, client]);

  useEffect(() => {
    if (user?.connectionType === "Group") {
      fetchGroupMembers(roomId);
    }
  }, [roomId, client]);

  const scrollToBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [data]);


  useEffect(() => {
    if (pageNumber > 0) {
      getMessage(roomId);
    }
  }, [pageNumber]);

  useEffect(() => {
    setPageNumber(0);
  }, [getlastdata, roomId]);

  useEffect(() => {
    getConnectionList();
  }, [alumniDetailsInfo?.userId]);

  useEffect(() => {
    setReplyTo(null)
    clearNotification(user?.connectionType, user?.connectionId);
  }, [user]);
  useEffect(() => {
    const cooldownStartTime = localStorage.getItem("cooldownStartTime");

    if (cooldownStartTime) {
      const elapsedTime = Date.now() - parseInt(cooldownStartTime, 10);
      const cooldownPeriod = 10000;

      if (elapsedTime < cooldownPeriod) {
        const remainingTime = cooldownPeriod - elapsedTime;
        setIsCooldown(true);

        setTimeout(() => {
          setIsCooldown(false);
          localStorage.removeItem("cooldownStartTime");
        }, remainingTime);
      } else {
        setIsCooldown(false);
        localStorage.removeItem("cooldownStartTime");
      }
    }
  }, []);

  // if (!user) return <Typography>Loading...</Typography>;

  const CheckdrawrWidth = user?.connectionId;


  console.log(replyTo, 'replytoo')


  return (
    <Box sx={{ display: "flex", gap: '1' }}>
      <ChatDrawer
        alumniDetailsInfo={alumniDetailsInfo}
        handleRoomChange={handleRoomChange}
        CheckdrawrWidth={CheckdrawrWidth}
        setRoomId={setRoomId}
        getContactList={getConnectionList}
        openChatDrawer={openChatDrawer}
        setOpenChatDrawer={setOpenChatDrawer}
        handleDrawerOpen={handleDrawerOpen}
        users={connectionList}
        setUser={setUser}
        generateUniqueId={generateUniqueId}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      {user?.connectionId || alumniDetailsInfo?.userId ? (


        <Main theme={theme} open={openChatDrawer}>
          <Grid container spacing={gridSpacing}>
            <Grid
              item
              xs
              zeroMinWidth
              sx={{
                display: emailDetails ? { xs: "none", sm: "flex" } : "flex",
              }}
            >
              <MainCard
                sx={{
                  bgcolor: theme.palette.mode === "dark" ? "dark.main" : "grey.50",
                }}
              >
                <Grid container spacing={gridSpacing}>
                  {/* === HEADER === */}
                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={1} wrap="nowrap">
                      {!isFromSearchBar && (
                        <Grid item>
                          <IconButton onClick={handleDrawerOpen} size="large">
                            <MenuRoundedIcon />
                          </IconButton>
                        </Grid>
                      )}

                      <Grid item xs zeroMinWidth>
                        <Grid container spacing={1} alignItems="center">
                          <Grid item>
                            <Avatar
                              alt={formatName(user?.connectionName)}
                              src={`data:image/*;base64, ${user?.image?.data}`}
                            />
                          </Grid>
                          <Grid
                            item
                            xs
                            zeroMinWidth
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography variant="h5" noWrap>
                              {formatName(user?.connectionName)}
                            </Typography>
                            {groupMemberImages[user?.id]?.length > 0 && (
                              <Box mt={0.5}>
                                <AvatarGroup max={6}>
                                  {groupMemberImages[user?.id]?.map((image, idx) => (
                                    <Avatar
                                      key={idx}
                                      alt="Member"
                                      src={`data:image/*;base64, ${image}`}
                                      sx={{ width: 30, height: 30, fontSize: 12 }}
                                    />
                                  ))}
                                </AvatarGroup>
                              </Box>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <IconButton onClick={handleUserChange} size="large">
                          <ErrorTwoToneIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                    <Divider sx={{ mt: 1.5, mb: 1 }} />
                  </Grid>

                  {/* === CHAT HISTORY === */}
                  <PerfectScrollbar
                    onScrollY={(container) => {
                      if (container.scrollTop === 0 && !getlastdata) {
                        setIsFetching(true);
                        setPageNumber((prevpage) => prevpage + 1);
                      }
                    }}
                    containerRef={(ref) => {
                      scrollContainerRef.current = ref;
                    }}
                    style={{
                      width: "100%",
                      height: "calc(100vh - 440px)",
                      overflowX: "hidden",
                      minHeight: 525,
                    }}
                  >
                    <CardContent>
                      <ChartHistory
                        theme={theme}
                        handleUserDetails={handleUserChange}
                        handleDrawerOpen={handleDrawerOpen}
                        user={user}
                        data={data}
                        onReply={(message) => setReplyTo(message)} // ✅ reply set
                      />
                      <span ref={scrollRef} />
                    </CardContent>
                  </PerfectScrollbar>

                  {/* === TEXT INPUT + REPLY UI === */}
                  <Grid item xs={12}>
                    {/* ✅ Reply preview */}
                    {replyTo && (
                      <Box
                        sx={{
                          px: 2,
                          py: 1,
                          mb: 1,
                          mx: 1,
                          backgroundColor:
                            theme.palette.mode === "dark" ? "#2a2f32" : "#f5f5f5",
                          borderLeft: "4px solid #1976d2",
                          borderRadius: "8px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="caption"
                            fontWeight={600}
                            color="primary"
                          >
                            Replying to: {replyTo.senderName}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontStyle: "italic", wordBreak: "break-word" }}
                          >
                            {replyTo.content}
                          </Typography>
                        </Box>
                        <IconButton size="small" onClick={() => setReplyTo(null)}>
                          ❌
                        </IconButton>
                      </Box>
                    )}

                    {/* ✅ Message Input */}
                    <Grid container spacing={1} alignItems="center">
                      <Grid item>
                        <IconButton
                          ref={anchorElEmoji}
                          aria-describedby={emojiId}
                          onClick={handleOnEmojiButtonClick}
                          size="large"
                        >
                          <MoodTwoToneIcon />
                        </IconButton>
                        <Popper
                          id={emojiId}
                          open={emojiOpen}
                          anchorEl={anchorElEmoji}
                          disablePortal
                          modifiers={[
                            {
                              name: "offset",
                              options: { offset: [-20, 20] },
                            },
                          ]}
                        >
                          <ClickAwayListener onClickAway={handleCloseEmoji}>
                            <>
                              {emojiOpen && (
                                <Picker
                                  Theme="dark"
                                  emojiStyle="apple"
                                  onEmojiClick={onEmojiClick}
                                  skinTone={SKIN_TONE_MEDIUM_DARK}
                                  disableAutoFocus
                                />
                              )}
                            </>
                          </ClickAwayListener>
                        </Popper>
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <TextField
                          value={message}
                          onKeyPress={handleEnter}
                          onChange={(e) => setMessage(e.target.value)}
                          multiline
                          fullWidth
                          rows={2}
                          placeholder="Type a message..."
                          variant="outlined"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor:
                                message.length > maxLength ? "red" : undefined,
                              "&:hover fieldset": {
                                borderColor:
                                  message.length > maxLength ? "red" : undefined,
                              },
                              "&.Mui-focused fieldset": {
                                borderColor:
                                  message.length > maxLength ? "red" : undefined,
                              },
                            },
                          }}
                          error={message.length > maxLength}
                        />
                        <Typography
                          variant="caption"
                          color={
                            message.length > maxLength ? "red" : "textSecondary"
                          }
                          sx={{ display: "block", marginTop: "5px" }}
                        >
                          {maxLength - message.length >= 0
                            ? `${maxLength - message.length} characters remaining`
                            : `${Math.abs(
                              maxLength - message.length
                            )} characters over limit`}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <IconButton
                          color="primary"
                          onClick={handleOnSend}
                          disabled={message.length > maxLength}
                          size="large"
                        >
                          <SendTwoToneIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </MainCard>
            </Grid>

            {emailDetails && (
              <Grid item sx={{ margin: { xs: "0 auto", md: "initial" } }}>
                <Box
                  sx={{
                    display: { xs: "block", sm: "none", textAlign: "right" },
                  }}
                >
                  <IconButton onClick={handleUserChange} sx={{ mb: -5 }} size="large">
                    <HighlightOffTwoToneIcon />
                  </IconButton>
                </Box>


                {/* ///UserDetails */}
                <UserDetails
                  setOpenChatDrawer={setOpenChatDrawer}
                  setCollapsed={setCollapsed}
                  fetchGroupMembers={fetchGroupMembers}
                  getContactList={getConnectionList}
                  connections={connectionList}
                  setUser={setUser}
                  groupMembers={groupMembers}
                  user={user}
                />
              </Grid>
            )}
          </Grid>
        </Main>
      ) : (
        <Main theme={theme} open={openChatDrawer}>
          <MainCard
            sx={{
              bgcolor: isDark ? "background.default" : "grey.50",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 0,
              boxShadow: "none",
            }}
          >
            <Box textAlign="center">
              <ChatBubbleOutline
                sx={{ fontSize: 64, color: theme.palette.text.secondary, mb: 2 }}
              />
              <Typography variant="h4" fontWeight={600}>
                Select a contact to start chatting
              </Typography>
              <Typography variant="body1" color="text.secondary" mt={1}>
                Your conversations will appear here once you choose a contact.
              </Typography>
            </Box>
          </MainCard>
        </Main>
      )}
    </Box>
  );
};

export default AlumniChatMainPage;
